<template>
  <v-navigation-drawer
    :value="isOpenTemplateDetails"
    @input="handlerInput"
    :width="windowSize.x > 1280 && false ? 'calc(100vw - 101px)' : '100vw'"
    max-width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index: 11;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3" style="overflow: hidden;">
      <BaseToolbar
        ref="base-toolbar"
        @close="close()"
        :title="$t('templates.detail.title')"
        :dark="false"
        type-title="icon"
        color="white"
      >
        <div class="d-flex align-center pr-4">
          <v-btn @click="editTemplate()" color="primary">
            {{ $t('actions.edit') }}
          </v-btn>
        </div>
      </BaseToolbar>
      <v-card-text
        v-if="isOpenTemplateDetails && translationSelected && translationSelected.template"
        class="pa-0 ma-0 d-flex"
        style="overflow-y:auto; height:calc(100vh - 64px);"
      >
        <iframe
          v-if="mode === 'desktop'"
          :srcdoc="translationSelected && translationSelected.template.replace('{{headers}}', '').replace('{{scripts}}', '')"
          frameborder="0"
          style="overflow-y:auto; height:100%; width:100%;"
        />
        <div
          v-else
          :style="{ backgroundImage: `url(${require('@/assets/svg/mobile-mask.svg')})` }"
          class="mx-auto my-8"
          style="
            width: 364px;
            height: 748px;
            position: relative;
            background-size: contain;
            display: block;"
        >
          <div
            style="position: absolute;
            width: inherit;
            height: inherit;
            padding: 40px 18px 65px 18px;"
          >
            <iframe
              :srcdoc="translationSelected && translationSelected.template.replace('{{headers}}', '').replace('{{scripts}}', '')"
              frameborder="0"
              style="overflow-y:auto; background-size: contain; border-radius: inherit; width: 100%; height: 100%;"
            />
          </div>
        </div>
        <v-sheet
          elevation="6"
          class="pa-0 ma-5 d-flex align-center"
          style="position: absolute; bottom: 0; left: 0;"
        >
          <v-btn-toggle
            v-model="mode"
            background-color="primary"
            color="primary"
            mandatory
            group
          >
            <v-btn value="desktop" class="ma-0">
              <v-icon>desktop_windows</v-icon>
            </v-btn>
            <v-btn value="mobile" class="ma-0">
              <v-icon>smartphone</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-divider vertical />
          <v-menu
            offset-y
            right
            top
            nudge-top="10px"
            min-width="250px"
            max-width="250px"
            style="z-index: 20;"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                ref="button-menu-translations"
                v-on="on"
                text
                tile
                height="50px"
                width="250px"
                class="justify-start text-truncate caption"
              >
                <div class="d-flex align-center">
                  <v-icon v-text="'translate'" color="primary" class="mr-3" />
                  <b v-text="translationSelected.name" />
                  <v-icon
                    v-text="translationSelected.is_default ? 'star' : 'star_border'"
                    :color="translationSelected.is_default ? 'amber darken-2' : ''"
                    style="position: absolute; right: 0;"
                  />
                </div>
              </v-btn>
            </template>
            <v-card ref="content-menu-tags">
              <v-card-title>
                {{ $tc('common.translation', 2) }}
              </v-card-title>
              <v-divider />
              <v-card-text
                v-if="!translations.length"
                style="max-height: 400px; overflow-y: auto;"
                class="pa-4"
              >
                <v-row dense>
                  <v-col>
                    <v-img
                      :src="require('@/assets/svg/box_empty.svg')"
                      height="150"
                      max-height="150px"
                      aspect-ratio="1"
                      contain
                    />
                    <div class="text-center">
                      {{ $t('common.no_results_found') }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-list v-else dense max-height="250px" class="overflow-y-auto">
                <template v-for="(translation, index) in translations">
                  <v-list-item
                    @click="translationSelected = translation"
                    :key="translation.id"
                  >
                    <v-icon v-text="'translate'" class="mr-3" />
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="translation.name"
                        class="grey--text text--darken-1 font-weight-bold subtitle-2"
                      />
                    </v-list-item-content>
                    <v-list-item-action class="flex-row align-center">
                      <v-icon
                        v-text="translation.is_default ? 'star' : 'star_border'"
                        :color="translation.is_default ? 'amber darken-2' : ''"
                      />
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index < translations.length - 1"
                    :key="index"
                  />
                </template>
              </v-list>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-card-text>
      <v-card-text v-else class="pa-0 d-flex align-center justify-center" style="overflow-y: auto;height: calc(100vh - 64px)">
        <v-alert
          :value="true"
          :color="alert.color"
          :class="alert.class"
          border="left"
          height="100%"
          width="100%"
          class="ma-0 d-flex align-center justify-center"
        >
          <div style="width: 100%;" class="d-flex flex-column align-center justify-center">
            <v-icon
              v-text="alert.icon"
              :color="alert.iconColor"
              size="50"
            />
            <div
              v-text="alert.text"
              class="overline font-weight-bold text-center"
              style="max-width: 160px;"
            />
          </div>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import languages from '@/data/languages.json'

export default {
  components: { BaseToolbar },
  data () {
    return {
      mode: 'desktop',
      translationSelected: null
    }
  },
  watch: {
    template () {
      this.setDefaultTranslation()
    }
  },
  computed: {
    ...mapGetters({
      windowSize: 'windowSize',
      template: 'templates/template',
      isOpenTemplateDetails: 'templates/isOpenTemplateDetails'
    }),
    translations () {
      if (this.template && this.template.translations) {
        return this.template.translations.map(translation => {
          const { name } = languages.find(({ code }) => translation.language_code === code)
          translation.name = name
          return translation
        })
      }
      return []
    },
    defaultTranslation () {
      if (this.template && this.template.translations && this.template.translations.length) {
        return this.template.translations[0]
      }
      return null
    },
    alert () {
      if (!this.translationSelected) {
        return {
          color: 'error lighten-4',
          icon: 'error',
          iconColor: 'error',
          class: 'error--text',
          text: 'Plantilla sin traducción por defecto'
        }
      }
      if (!this.translationSelected.template) {
        return {
          color: 'orange lighten-4',
          icon: 'warning',
          iconColor: 'warning',
          class: 'warning--text',
          text: this.$t('templates.detail.empty_design')
        }
      }
      return {
        color: 'blue lighten-4',
        icon: 'info',
        iconColor: 'info',
        class: 'info--text',
        text: this.$t('templates.preview_not_available')
      }
    }
  },
  methods: {
    ...mapMutations({
      closeTemplateDetails: 'templates/closeTemplateDetails',
      openTemplateEditor: 'templates/openTemplateEditor'
    }),
    handlerInput (arg) {
      if (!arg) { this.close() }
    },
    setDefaultTranslation () {
      this.translationSelected = this.template.translations.find(e => e.is_default)
    },
    editTemplate () {
      this.close()
      this.openTemplateEditor({ mode: 'edit' })
    },
    close () {
      this.closeTemplateDetails()
      this.mode = 'desktop'
    }
  }
}
</script>
